import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Mutation, Query } from 'react-apollo';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import gql from 'graphql-tag';
import moment from 'moment';
import { ADMIN_CREATE_PRODUCT } from '../../libs/Mutations';
import theme from '../../theme';

const MANUFACTURERS_QUERY = gql`
query getManufacturersForDialog {
	admin {
		manufacturers {
			manufacturerId
			displayName
		}
	}
}
`;

const COMPONENT_TYPES = [
	{ value: '', label: '(none)' },
	{ value: 'MODULAR', label: 'Modular' },
	{ value: 'MASTER', label: 'Master' },
	{ value: 'STANDALONE', label: 'Standalone' },
	{ value: 'INVERTER_CONTROLLER', label: 'Inverter controller' },
];

const styles = {
	sectionTitle: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(1),
		fontWeight: 600,
		textTransform: 'uppercase',
		fontSize: 13,
		color: theme.palette.grey[700],
	},
};

const initialState = {
	manufacturerId: '',
	model: '',
	modelNameType: 'INTERNAL',
	productType: 'BATTERY',
	batteryComponentType: '',
	isSmart: false,
	nominalStorageKwh: '',
	nominalUsableKwh: '',
	nominalVoltage: '',
	nominalMaxPowerKw: '',
	wattage: '',
	firetested: '',
	approvedDate: null,
	expiryDate: null,
	formError: null,
};

class AdminAddProductDialog extends React.Component {
	constructor(props) {
		super(props);
		this.state = { ...initialState };
	}

	componentDidUpdate(prevProps) {
		if (this.props.open && !prevProps.open) {
			this.setState({ ...initialState });
		}
	}

	handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		this.setState({ [name]: type === 'checkbox' ? checked : value });
	};

	handleSelect = (name) => (e) => this.setState({ [name]: e.target.value });

	buildProductInput = () => {
		const s = this.state;
		const num = (v) => {
			if (v === '' || v == null) return null;
			const n = parseFloat(v);
			return Number.isFinite(n) ? n : null;
		};
		const intv = (v) => {
			if (v === '' || v == null) return null;
			const n = parseInt(v, 10);
			return Number.isFinite(n) ? n : null;
		};
		return {
			brand: null,
			model: s.model || null,
			modelNameType: s.modelNameType || 'INTERNAL',
			productType: s.productType || 'BATTERY',
			batteryComponentType: s.batteryComponentType || null,
			isSmart: s.isSmart,
			nominalStorageKwh: num(s.nominalStorageKwh),
			nominalUsableKwh: num(s.nominalUsableKwh),
			nominalVoltage: s.nominalVoltage || null,
			nominalMaxPowerKw: num(s.nominalMaxPowerKw),
			wattage: intv(s.wattage),
			firetested: s.firetested || null,
			approvedDate: s.approvedDate ? moment(s.approvedDate).format('YYYY-MM-DD') : null,
			expirydate: s.expiryDate ? moment(s.expiryDate).format('YYYY-MM-DD') : null,
		};
	};

	handleSubmit = (createProduct) => {
		const { model, manufacturerId } = this.state;
		if (!manufacturerId) {
			this.setState({ formError: 'Select a manufacturer.' });
			return;
		}
		if (!String(model || '').trim()) {
			this.setState({ formError: 'Enter a model name.' });
			return;
		}
		this.setState({ formError: null });
		createProduct({
			variables: {
				manufacturerId: parseInt(manufacturerId),
				product: this.buildProductInput(),
			},
		})
			.then(() => {
				if (typeof this.props.onClose === 'function') this.props.onClose(true);
			})
			.catch(() => {});
	};

	render() {
		const { classes, open, onClose } = this.props;
		const s = this.state;

		return (
			<Dialog open={open} onClose={() => onClose(false)} maxWidth="md" fullWidth>
				<DialogTitle>Add Product (Admin)</DialogTitle>
				<Mutation mutation={ADMIN_CREATE_PRODUCT}>
					{(createProduct, { loading, error }) => (
						<ValidatorForm
							onSubmit={() => this.handleSubmit(createProduct)}
							onError={(errs) => console.warn(errs)}
						>
							<DialogContent>
								<Typography className={classes.sectionTitle}>Manufacturer</Typography>
								<Query query={MANUFACTURERS_QUERY} fetchPolicy="network-only">
									{({ data }) => {
										const manufacturers = data?.admin?.manufacturers || [];
										return (
											<FormControl variant="outlined" fullWidth>
												<InputLabel>Manufacturer *</InputLabel>
												<Select
													name="manufacturerId"
													value={s.manufacturerId}
													onChange={this.handleSelect('manufacturerId')}
													label="Manufacturer *"
												>
													<MenuItem value="" disabled>Select manufacturer</MenuItem>
													{manufacturers.map((m) => (
														<MenuItem key={m.manufacturerId} value={m.manufacturerId}>
															{m.displayName}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										);
									}}
								</Query>

								<Typography className={classes.sectionTitle}>Product identity</Typography>
								<Grid container spacing={2}>
									<Grid item xs={12} md={6}>
										<TextValidator
											name="model"
											label="Model name *"
											value={s.model}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={12} md={6}>
										<FormControl variant="outlined" fullWidth>
											<InputLabel>Name type</InputLabel>
											<Select
												name="modelNameType"
												value={s.modelNameType}
												onChange={this.handleSelect('modelNameType')}
												label="Name type"
											>
												<MenuItem value="CEC">CEC</MenuItem>
												<MenuItem value="INTERNAL">Internal</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									<Grid item xs={12} md={4}>
										<FormControl variant="outlined" fullWidth>
											<InputLabel>Product type</InputLabel>
											<Select
												name="productType"
												value={s.productType}
												onChange={this.handleSelect('productType')}
												label="Product type"
											>
												<MenuItem value="BATTERY">Battery</MenuItem>
												<MenuItem value="INVERTER">Inverter</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									<Grid item xs={12} md={4}>
										<FormControl variant="outlined" fullWidth>
											<InputLabel>Component type</InputLabel>
											<Select
												value={s.batteryComponentType}
												onChange={this.handleSelect('batteryComponentType')}
												label="Component type"
											>
												{COMPONENT_TYPES.map((o) => (
													<MenuItem key={o.value || 'empty'} value={o.value}>
														{o.label}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>
									<Grid item xs={12} md={4}>
										<FormControlLabel
											control={
												<Checkbox
													name="isSmart"
													checked={s.isSmart}
													onChange={this.handleChange}
													color="primary"
												/>
											}
											label="Is smart"
										/>
									</Grid>
								</Grid>

								<Typography className={classes.sectionTitle}>Capacity / electrical</Typography>
								<Grid container spacing={2}>
									<Grid item xs={12} md={4}>
										<TextValidator
											name="nominalStorageKwh"
											label="Nominal storage (kWh)"
											value={s.nominalStorageKwh}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										<TextValidator
											name="nominalUsableKwh"
											label="Nominal usable (kWh)"
											value={s.nominalUsableKwh}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										<TextValidator
											name="nominalVoltage"
											label="Nominal voltage"
											value={s.nominalVoltage}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										<TextValidator
											name="nominalMaxPowerKw"
											label="Nominal max power (kW)"
											value={s.nominalMaxPowerKw}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										<TextValidator
											name="wattage"
											label="Wattage (W)"
											value={s.wattage}
											onChange={this.handleChange}
											fullWidth
											variant="outlined"
										/>
									</Grid>
								</Grid>

								<Typography className={classes.sectionTitle}>CEC / dates (optional)</Typography>
								<MuiPickersUtilsProvider utils={MomentUtils}>
									<Grid container spacing={2}>
										<Grid item xs={12} md={4}>
											<KeyboardDatePicker
												label="Approved date"
												value={s.approvedDate}
												onChange={(d) => this.setState({ approvedDate: d })}
												format="DD/MM/YYYY"
												fullWidth
												inputVariant="outlined"
												clearable
											/>
										</Grid>
										<Grid item xs={12} md={4}>
											<KeyboardDatePicker
												label="Expiry date"
												value={s.expiryDate}
												onChange={(d) => this.setState({ expiryDate: d })}
												format="DD/MM/YYYY"
												fullWidth
												inputVariant="outlined"
												clearable
											/>
										</Grid>
										<Grid item xs={12} md={4}>
											<TextValidator
												name="firetested"
												label="Fire tested"
												value={s.firetested}
												onChange={this.handleChange}
												fullWidth
												variant="outlined"
											/>
										</Grid>
									</Grid>
								</MuiPickersUtilsProvider>

								{s.formError && (
									<Typography color="error" style={{ marginTop: 16 }}>
										{s.formError}
									</Typography>
								)}
								{error && (
									<Typography color="error" style={{ marginTop: 16 }}>
										{error.graphQLErrors && error.graphQLErrors.length
											? error.graphQLErrors.map((e) => e.message).join(' ')
											: error.message}
									</Typography>
								)}
							</DialogContent>
							<DialogActions>
								<Button onClick={() => onClose(false)} disabled={loading}>
									Cancel
								</Button>
								<Button type="submit" variant="contained" color="primary" disabled={loading}>
									{loading ? 'Saving…' : 'Save product'}
								</Button>
							</DialogActions>
						</ValidatorForm>
					)}
				</Mutation>
			</Dialog>
		);
	}
}

export default withStyles(styles)(AdminAddProductDialog);
